import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

import { TarefaDTO } from "@/types/tarefa.type";
import {
  avaliarStatusPrazo,
  formatRelativeTime,
  identificarPapelUsuario,
  isTarefaVencida,
  JobBadge,
  MensagemNaoLidaBadge,
  PrazoBadge,
  RoleBadge,
} from "./TarefaNotificacaoBadges";

interface TarefaNotificacaoItemProps {
  tarefa: TarefaDTO;
  userId?: string | number;
  index: number;
  /** Aba "Mensagens": destaca a mensagem não lida. Aba "Pendentes" nunca mostra este badge. */
  mensagemNaoLida?: boolean;
  onNavigate: () => void;
}

export function TarefaNotificacaoItem({
  tarefa,
  userId,
  index,
  mensagemNaoLida = false,
  onNavigate,
}: TarefaNotificacaoItemProps) {
  const papel = identificarPapelUsuario(tarefa, userId);
  const statusPrazo = avaliarStatusPrazo(tarefa);
  const atrasado = isTarefaVencida(tarefa);

  return (
    <Link
      to={`/tarefas/${tarefa.id}`}
      onClick={onNavigate}
      className={cn(
        "group flex flex-col gap-2 p-3.5 outline-none transition-all duration-200",
        atrasado
          ? "border-l-2 border-destructive bg-destructive/5 hover:bg-destructive/10 focus:bg-destructive/10"
          : "hover:bg-muted/40 focus:bg-muted/40",
      )}
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <span
        className={cn(
          "line-clamp-2 text-sm font-medium leading-snug transition-colors",
          atrasado ? "text-destructive group-hover:text-destructive" : "group-hover:text-primary",
        )}
      >
        {tarefa.nome}
      </span>

      <div className="flex flex-wrap items-center gap-1.5">
        <RoleBadge papel={papel} />
        <MensagemNaoLidaBadge visivel={mensagemNaoLida} />
        <PrazoBadge status={statusPrazo} dataPrazo={tarefa.dataPrazo} />
        <JobBadge pit={tarefa.job?.pit} />
      </div>

      <div className="flex items-center text-[11px] font-medium text-muted-foreground/80">
        <Clock className="mr-1.5 h-3 w-3" />
        {formatRelativeTime(tarefa.criadoEm)}
      </div>
    </Link>
  );
}
